import React, { useEffect, useState } from 'react'
import { Pane, Text } from 'evergreen-ui'
import { FaCheck } from 'react-icons/fa'
import DetailClassInterviweLevel1 from '../DetailClassInterviwe/DetailClassInterviweLevel1';
import DetailClassInterviweLevel2 from '../DetailClassInterviwe/DetailClassInterviweLevel2';
import DetailComment from '../DetailComment/DetailComment';
const DetailRegister_1 = ({ DataRegister }) => {
  const validCodes = [
    "1101",
    "1102",
    "1103",
    "1106",
    "1110",
    "1207",
    "1208",
    "1301",
    "1302",
    "1304",
    "1310",
  ];
  const [ListMajor, setListMajor] = useState([]);


  const GetListMajor = (DATAREGISTER) => {
    const List = [];
    DATAREGISTER.forEach((items) => {
      if (items.Major1_MAJOR_ID !== null) {
        List.push({
          Major_LEVEL_OPEN_ID: items.Major1_LEVEL_OPEN_ID,
          Major_LEVEL_OPEN_NAME: items.Major1_LEVEL_OPEN_NAME,
          Major_MAJOR_CLASSROOM: items.Major1_MAJOR_CLASSROOM,
          Major_MAJOR_CLASSROOM2: items.Major1_MAJOR_CLASSROOM2,
          Major_MAJOR_CLASSROOM3: items.Major1_MAJOR_CLASSROOM3,
          Major_MAJOR_ID: items.Major1_MAJOR_ID,
          Major_MAJOR_NAME: items.Major1_MAJOR_NAME,
          Major_course_year: items.Major1_course_year,
          Major_course_year_id: items.Major1_course_year_id,
          Major_course_year_name: items.Major1_course_year_name,
          Major_faculty_name: items.Major1_faculty_name,
          REGISTER_TYPE_ID: items.REGISTER_TYPE_ID,
          REGISTER_ID: items.REGISTER_ID,
          ROB_ID: items.ROB_ID,
          REGISTER_STATUS_BILL_ROBFULL_BOOK: items.REGISTER_STATUS_BILL_ROBFULL_BOOK,
          REGISTER_STATUS_BILL_ROB1_BOOK: items.REGISTER_STATUS_BILL_ROB1_BOOK,
          REGISTER_STATUS_BILL_ROB1_NO: items.REGISTER_STATUS_BILL_ROB1_NO,
          REGISTER_STATUS_BILL_ROB1_COUNT: items.REGISTER_STATUS_BILL_ROB1_COUNT,
          REGISTER_STATUS_BILL_ROB2_BOOK: items.REGISTER_STATUS_BILL_ROB2_BOOK,
          REGISTER_STATUS_BILL_ROB2_NO: items.REGISTER_STATUS_BILL_ROB2_NO,
          REGISTER_STATUS_BILL_ROB2_COUNT: items.REGISTER_STATUS_BILL_ROB2_COUNT,
          ROB_YEAR: items.ROB_YEAR,
          REGISTER_STATUS_BILL_ROBFULL_NO: items.REGISTER_STATUS_BILL_ROBFULL_NO,
          REGISTER_STATUS_BILL_ROBFULL_COUNT: items.REGISTER_STATUS_BILL_ROBFULL_COUNT,
          CITIZEN: items.CITIZENT_LOGIN,
          REGISTER_STATUS: items.REGISTER_STATUS,
        });
      }
      if (items.Major2_MAJOR_ID !== null) {
        List.push({
          Major_LEVEL_OPEN_ID: items.Major2_LEVEL_OPEN_ID,
          Major_LEVEL_OPEN_NAME: items.Major2_LEVEL_OPEN_NAME,
          Major_MAJOR_CLASSROOM: items.Major2_MAJOR_CLASSROOM,
          Major_MAJOR_CLASSROOM2: items.Major2_MAJOR_CLASSROOM2,
          Major_MAJOR_CLASSROOM3: items.Major2_MAJOR_CLASSROOM3,
          Major_MAJOR_ID: items.Major2_MAJOR_ID,
          Major_MAJOR_NAME: items.Major2_MAJOR_NAME,
          Major_course_year: items.Major2_course_year,
          Major_course_year_id: items.Major2_course_year_id,
          Major_course_year_name: items.Major2_course_year_name,
          Major_faculty_name: items.Major2_faculty_name,
          REGISTER_TYPE_ID: items.REGISTER_TYPE_ID,
          REGISTER_ID: items.REGISTER_ID,
          ROB_ID: items.ROB_ID,
          REGISTER_STATUS_BILL_ROBFULL_BOOK: items.REGISTER_STATUS_BILL_ROBFULL_BOOK,
          REGISTER_STATUS_BILL_ROB1_BOOK: items.REGISTER_STATUS_BILL_ROB1_BOOK,
          REGISTER_STATUS_BILL_ROB1_NO: items.REGISTER_STATUS_BILL_ROB1_NO,
          REGISTER_STATUS_BILL_ROB1_COUNT: items.REGISTER_STATUS_BILL_ROB1_COUNT,
          REGISTER_STATUS_BILL_ROB2_BOOK: items.REGISTER_STATUS_BILL_ROB2_BOOK,
          REGISTER_STATUS_BILL_ROB2_NO: items.REGISTER_STATUS_BILL_ROB2_NO,
          REGISTER_STATUS_BILL_ROB2_COUNT: items.REGISTER_STATUS_BILL_ROB2_COUNT,
          ROB_YEAR: items.ROB_YEAR,
          REGISTER_STATUS_BILL_ROBFULL_NO: items.REGISTER_STATUS_BILL_ROBFULL_NO,
          REGISTER_STATUS_BILL_ROBFULL_COUNT: items.REGISTER_STATUS_BILL_ROBFULL_COUNT,
          CITIZEN: items.CITIZENT_LOGIN,
          REGISTER_STATUS: items.REGISTER_STATUS,
        });
      }
      if (items.Major3_MAJOR_ID !== null) {
        List.push({
          Major_LEVEL_OPEN_ID: items.Major3_LEVEL_OPEN_ID,
          Major_LEVEL_OPEN_NAME: items.Major3_LEVEL_OPEN_NAME,
          Major_MAJOR_CLASSROOM: items.Major3_MAJOR_CLASSROOM,
          Major_MAJOR_CLASSROOM2: items.Major3_MAJOR_CLASSROOM2,
          Major_MAJOR_CLASSROOM3: items.Major3_MAJOR_CLASSROOM3,
          Major_MAJOR_ID: items.Major3_MAJOR_ID,
          Major_MAJOR_NAME: items.Major3_MAJOR_NAME,
          Major_course_year: items.Major3_course_year,
          Major_course_year_id: items.Major3_course_year_id,
          Major_course_year_name: items.Major3_course_year_name,
          Major_faculty_name: items.Major3_faculty_name,
          REGISTER_TYPE_ID: items.REGISTER_TYPE_ID,
          REGISTER_ID: items.REGISTER_ID,
          ROB_ID: items.ROB_ID,
          REGISTER_STATUS_BILL_ROBFULL_BOOK: items.REGISTER_STATUS_BILL_ROBFULL_BOOK,
          REGISTER_STATUS_BILL_ROB1_BOOK: items.REGISTER_STATUS_BILL_ROB1_BOOK,
          REGISTER_STATUS_BILL_ROB1_NO: items.REGISTER_STATUS_BILL_ROB1_NO,
          REGISTER_STATUS_BILL_ROB1_COUNT: items.REGISTER_STATUS_BILL_ROB1_COUNT,
          REGISTER_STATUS_BILL_ROB2_BOOK: items.REGISTER_STATUS_BILL_ROB2_BOOK,
          REGISTER_STATUS_BILL_ROB2_NO: items.REGISTER_STATUS_BILL_ROB2_NO,
          REGISTER_STATUS_BILL_ROB2_COUNT: items.REGISTER_STATUS_BILL_ROB2_COUNT,
          ROB_YEAR: items.ROB_YEAR,
          REGISTER_STATUS_BILL_ROBFULL_NO: items.REGISTER_STATUS_BILL_ROBFULL_NO,
          REGISTER_STATUS_BILL_ROBFULL_COUNT: items.REGISTER_STATUS_BILL_ROBFULL_COUNT,
          CITIZEN: items.CITIZENT_LOGIN,
          REGISTER_STATUS: items.REGISTER_STATUS,
        });
      }
    });
    setListMajor(List);
  };

  useEffect(() => {
    GetListMajor(DataRegister);
  }, [DataRegister]);

  return (
    <>
      <Pane
        color="#fff"
        backgroundColor="#fff"
        height="100%"
        paddingY={4}
        paddingX={5}
        fontSize={14}
        fontFamily=""
        margin={0}
        fontWeight={700}
        display="flex"
        flexDirection="column"
        marginTop={5}
      >
        <Text
          fontWeight={600}
          fontFamily=""
          fontSize={14}
          paddingTop={5}
          marginBottom={10}
        >
          รายละเอียดที่สมัคร
        </Text>
        {
          ListMajor.map((item, index) => (
            <div key={index} style={{ color: "#000000" }}>
              <Text fontWeight={700} style={{ color: "#fe7f2d" }}>
                ลำดับที่ {index + 1}
              </Text>
              &nbsp; หลักสูตร
              {item.Major_LEVEL_OPEN_NAME +
                " " +
                item.Major_course_year +
                " ปี  " +
                item.Major_MAJOR_ID +
                " : สาขาวิชา" +
                item.Major_MAJOR_NAME}

              <br />

              {/* ใส่ห้องสอบสัมภาษณ์ */}

              {
                (DataRegister[0].ROB_ID === "179" || DataRegister[0].ROB_ID === "183" || DataRegister[0].ROB_ID === "184"|| DataRegister[0].ROB_ID === "186" || DataRegister[0].ROB_ID === "191" || DataRegister[0].ROB_ID === "182" || DataRegister[0].ROB_ID === "187") ?
                  (
                    <>
                      {
                        (DataRegister[0].REGISTER_TYPE_ID === "1" || DataRegister[0].REGISTER_TYPE_ID === "5") ?
                          (
                            <>
                              {
                                index + 1 === 1 && (
                                  <>
                                    <DetailClassInterviweLevel1 DataRegister={item} />
                                  </>
                                )
                              }
                              {
                                index + 1 === 2 && (
                                  <>
                                    <DetailClassInterviweLevel2 DataRegister={item} />
                                  </>
                                )
                              }
                            </>
                          ) : (DataRegister[0].REGISTER_TYPE_ID === "4" || DataRegister[0].REGISTER_TYPE_ID === "7") ?
                            (
                              <>
                                {
                                  index + 1 === 1 && (
                                    <>
                                      <DetailClassInterviweLevel1 DataRegister={item} />
                                    </>
                                  )
                                }
                                {
                                  index + 1 === 2 && (
                                    <>
                                      <DetailClassInterviweLevel2 DataRegister={item} />
                                    </>
                                  )
                                }
                              </>
                            ) : (DataRegister[0].REGISTER_TYPE_ID === "6") ?
                            (
                              <>
                                {
                                  index + 1 === 1 && (
                                    <>
                                      <DetailClassInterviweLevel1 DataRegister={item} />
                                    </>
                                  )
                                }
                                {
                                  index + 1 === 2 && (
                                    <>
                                      <DetailClassInterviweLevel2 DataRegister={item} />
                                    </>
                                  )
                                }
                              </>
                            ) : (DataRegister[0].REGISTER_TYPE_ID === "2" || DataRegister[0].REGISTER_TYPE_ID === "3") ?
                            (
                              <>
                                {
                                  index + 1 === 1 && (
                                    <>
                                      <DetailClassInterviweLevel1 DataRegister={item} />
                                    </>
                                  )
                                }
                              </>
                            ) : (<></>)
                      
                      }
                    </>
                  ) : (<></>)
              }



              {/* ใส่ห้องสอบสัมภาษณ์ */}
            </div>
          ))
        }

      </Pane>
      <DetailComment DataRegister={DataRegister} />
    </>
  )
}

export default DetailRegister_1